import React, { useEffect, useState } from 'react';
import { getVentilatorMode } from '../../helper/mode-helper';
import { TEMP_MODE } from '../../common/ENUMS/VENTILATOR_MODES_ENUM';
import { SET_PARAMETERS, PARAMETER_UNIT_IDS } from '../../common/ENUMS/PARAMETER_ENUM';
import { connect } from "react-redux";
import arrowUp from "../../common/images/arrow_up.png";
import arrowDown from "../../common/images/arrow_down.png";
import './VentilatorSetParamsDesktopView.scss'

function VentilatorSetParamsDesktopView({
    expanded,
    setExpanded,
    params
}) {
    const containerHeight = (() => {
        const baseHeight = 12;
        const rowHeight = 16;
        const perRow = 7;

        if (!expanded) return `${baseHeight}%`;

        const extraRows = Math.ceil(
            Math.max(params.length - perRow, 0) / perRow
        );

        return `${baseHeight + extraRows * rowHeight}%`;
    })();

    return (
        <div className="vital-footer-container" style={{ height: containerHeight }}>
            <div className="footer-param-box-values">
                {params.map((item, index) => (
                    <div className="footer-param-box" key={index}>
                        <div className="footer-param-name">{item.title}</div>
                        <div className="footer-param-value">{item.value}</div>
                        <div className="footer-param-unit">{item.unit}</div>
                    </div>
                ))}
            </div>

            <div
                className="footer-param-box-arrow"
                onClick={() => setExpanded(!expanded)}
            >
                <img
                    src={expanded ? arrowDown : arrowUp}
                    alt="toggle"
                />
            </div>
        </div>
    );
}


export default VentilatorSetParamsDesktopView;